import { render, staticRenderFns } from "./SelecionarTipoPedidoView.vue?vue&type=template&id=e3d657a0&"
import script from "./SelecionarTipoPedidoView.vue?vue&type=script&lang=js&"
export * from "./SelecionarTipoPedidoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports